var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_1254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.17505 0.989258C6.78864 0.989258 4.49786 1.93805 2.81177 3.62527C1.12393 5.31316 0.175516 7.60226 0.175049 9.98926C0.175049 12.3752 1.12427 14.666 2.81177 16.3532C4.49786 18.0405 6.78864 18.9893 9.17505 18.9893C11.5615 18.9893 13.8522 18.0405 15.5383 16.3532C17.2258 14.666 18.175 12.3752 18.175 9.98926C18.175 7.60327 17.2258 5.31249 15.5383 3.62527C13.8522 1.93805 11.5615 0.989258 9.17505 0.989258Z",
    fill: "url(#paint0_linear_425_1254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24893 9.89429C6.87299 8.75129 8.62237 7.99768 9.49706 7.6336C11.9974 6.59396 12.5163 6.4134 12.8552 6.40728C12.9297 6.40608 13.0956 6.42451 13.2039 6.51205C13.2939 6.58587 13.3192 6.68572 13.3319 6.75582C13.3431 6.82585 13.3586 6.98546 13.346 7.11005C13.211 8.53318 12.6246 11.9866 12.3264 13.5806C12.2013 14.2551 11.9524 14.4812 11.7119 14.5033C11.1888 14.5514 10.7922 14.1579 10.286 13.8262C9.49424 13.3068 9.04706 12.9837 8.27784 12.477C7.38909 11.8914 7.96565 11.5696 8.4719 11.0436C8.60409 10.9059 10.9075 8.81133 10.9511 8.62135C10.9567 8.59758 10.9624 8.50899 10.9089 8.4623C10.8569 8.41547 10.7796 8.43151 10.7233 8.44416C10.6432 8.46216 9.37893 9.2986 6.92643 10.9533C6.56784 11.2 6.24299 11.3202 5.95049 11.3139C5.62987 11.307 5.01112 11.1322 4.55128 10.9829C3.98878 10.7996 3.54018 10.7027 3.57956 10.3915C3.59924 10.2295 3.82284 10.0637 4.24893 9.89429Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_425_1254",
    x1: 9.17505,
    y1: 0.989258,
    x2: 9.17505,
    y2: 18.9893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_1254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.175049 0.989258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.8d1e6ae0093686913dffa0d8999173c4.svg";
export { ForwardRef as ReactComponent };